<template>
  <div>
    <b-row class="mt-5">
      <b-col md="9">
        <div class="container-fluid">
          <div v-for="(featureGroup,group) in sortedFeatures">

            <b-row class="justify-content-center align-items-center">
              <b-button v-b-toggle="`feature-group-${convertGroupNameUsableForCollapse(group)}`"
                        class="w-100 p-2 col-lg-11 my-3">
                {{ group }}

              </b-button>
              <b-icon-pen-fill class="col-lg-1"
                               v-b-modal="`feature-category-${convertGroupNameUsableForCollapse(group)}`"/>
              <b-modal :id="`feature-category-${convertGroupNameUsableForCollapse(group)}`" hide-footer>
                <div class="text-right">

                  <feature-category-manager @changeCategories="refreshComponent" :product="product"
                                            :feature-category="group"/>

                </div>
              </b-modal>
            </b-row>

            <b-collapse :id="`feature-group-${convertGroupNameUsableForCollapse(group)}`">
              <div v-for="feature in featureGroup">
                <product-feature-item :product="product" :productFeature="feature"/>
              </div>
            </b-collapse>

          </div>
        </div>
      </b-col>
      <b-col md="3" class="mt-4">

        <feature-search @selectedFeature="addFeature"/>


      </b-col>
    </b-row>
  </div>
</template>
<script>
import FeatureSearch from "../../product/productFeatureComponents/FeatureSearch.vue";
import ProductFeatureItem from "../../product/productFeatureComponents/ProductFeatureItem.vue";
import FeatureCategoryManager from "../../product/productFeatureComponents/FeatureCategoryManager.vue";
import {addFeatureToProduct, removeChildFeature} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {baseFeature} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "FeaturesManager",
  components: {FeatureCategoryManager, FeatureSearch, ProductFeatureItem},
  props: {
    features: {},
    product: {},
  },
  data() {
    return {
      baseFeature,
    };
  },
  computed: {
    removeChildFeature,
    featureCategories() {
      let categories = []


      this.product.features.forEach((item) => {

        categories.push(item.extra)

      })

      return categories

    },
    sortedFeatures() {
      let features = this.features;


      features = removeChildFeature(features)

      // sort features base on item_order
      features = features.sort((a, b) => b.extra.item_order - a.extra.item_order);

      // group features base on category
      let featureGroup = features.reduce((acc, item) => {
        const category = item.extra.category;

        if (!acc[category]) {
          acc[category] = [];
        }

        acc[category].push(item);

        return acc;
      }, {});


      // add category info to each group
      let allFeatureCategories = this.featureCategories

      allFeatureCategories.sort((a, b) => b.category_order - a.category_order);
      let sortedFeatureGroup = {};
      for (let i = 0; i < allFeatureCategories.length; i++) {
        let category = allFeatureCategories[i].category;
        sortedFeatureGroup[category] = featureGroup[category];
      }

      // remove empty groups
      sortedFeatureGroup = this.removeEmptyGroups(sortedFeatureGroup)
      console.log(sortedFeatureGroup)

      return this.groupByType(sortedFeatureGroup)
    },
  },
  methods: {
    addFeatureToProduct,
    groupByType(features) {
      Object.entries(features).forEach(item => {
        let group = item[0]
        let items = item[1]
        let checkboxGroup = features[group].reduce((acc, item) => {
          if (item.feature.type === "checkbox") {
            let checkboxGroupName = item.extra.group
            if (!acc[checkboxGroupName]) {
              acc[checkboxGroupName] = [];
            }
            acc[checkboxGroupName].push(item);
          }
          return acc;
        }, {})
        let unCheckboxGroup = features[group].filter(item => item.feature.type !== "checkbox")
        features[group] = []
        Object.entries({...checkboxGroup, ...unCheckboxGroup}).forEach(newGenFeature => {
          let item = newGenFeature[1];
          if (Array.isArray(item)) {
            features[group].push({
              items: item,
              extra: item[0].extra
            })
          } else {
            features[group].push(item)
          }
        })
        features[group].sort((a, b) => b.extra.item_order - a.extra.item_order)

      })


      let result = {}
      // set order of checkbox group to correct order
      Object.entries(features).forEach(reshapeFeature => {
        let group = reshapeFeature[0]
        let items = reshapeFeature[1]
        result[group] = []
        items.forEach(item => {
          if (item.items != undefined) {
            result[group].push(item.items)
          } else {
            result[group].push(item)
          }
        })
      })
      return result
    },
    removeEmptyGroups(features) {
      let result = {}

      Object.entries(features).forEach(item => {
        let group = item[0]
        let items = item[1]
        if (items != undefined && items.length > 0) {
          result[group] = items
        }
      })

      return result

    },
    addFeature(feature) {
      this.addFeatureToProduct(feature, this.product)
      toast("با موفقیت اضافه شد","با موفقیت اضافه شد")
    },
    convertGroupNameUsableForCollapse(group) {
      return group.replaceAll(' ', '-')
    },
    refreshComponent() {
      this.$forceUpdate()
    }
  }
};
</script>
<style scoped>


</style>
